// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import UserForm from "./UserForm";
import { RouteComponentProps } from "@reach/router";
import PageHeader from "../../../components/PageHeader";
import PageTitle from "../../../components/PageTitle";
import PageBody from "../../../components/PageBody";
import { AuthentifiedUser } from "../../../../api/backend-openapi";
import { useStore } from "effector-react";
import { authentifiedUserStore } from "../../../../state/auth/AuthStore";
import { NboAction } from "../../../types/AuthTypes";

interface UserEditProps extends RouteComponentProps {
  userId?: string;
}

const UserScreen: React.FunctionComponent<UserEditProps> = (
  props: UserEditProps
) => {
  const { t } = useTranslation();
  const authentifiedUser: AuthentifiedUser | null = useStore(
    authentifiedUserStore
  );
  const canEdit: boolean =
    authentifiedUser?.rights.nboUserManagement?.includes(NboAction.nboUpdate) ||
    false;
  const canValidate: boolean =
    authentifiedUser?.rights.nboUserManagement?.includes(
      NboAction.nboValidate
    ) || false;
  const canDelete: boolean =
    authentifiedUser?.rights.nboUserManagement?.includes(NboAction.nboDelete) ||
    false;

  const [editMode, setEditMode] = useState<boolean>(false);
  const { userId } = props;

  return (
    <>
      <PageHeader>
        <PageTitle
          title={t(editMode ? "edit_user.title" : "detail_user.title")}
        />
      </PageHeader>
      <PageBody>
        <UserForm
          userId={userId ? userId : ""}
          editMode={editMode}
          setEditMode={setEditMode}
          canEdit={canEdit}
          canValidate={canValidate}
          canDelete={canDelete}
        />
      </PageBody>
    </>
  );
};

export default UserScreen;
